import AnimatedChoices from '@components/competitions/levels/imamreza/AnimatedChoice';
import CompetitionGuide from '@components/competitions/levels/imamreza/CompetitionGuide';
import {MainPage} from '@components/competitions/levels/imamreza/MainPage';
import Mobile from '@components/competitions/levels/imamreza/Mobile';
import Result from '@components/competitions/levels/imamreza/Result';
import {CompetitionImamrezaContext, PersonalityType} from '@context/CompetitionImamrezaContext';
import {useScopedTranslation} from '@hooks/useScopedTranslation';
import CloseIcon from '@icons/CloseIcon';
import scopedI18n from '@locale/scoped-i18n';
import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	IconButton,
	Slide,
	useMediaQuery,
	useTheme
} from '@mui/material';
import {TransitionProps} from '@mui/material/transitions';
import socketCompetition from '@sockets/competition';
import {saveLang} from '@utils/langStorage';
import React, {forwardRef, ReactElement, Ref, useEffect, useState} from 'react';
import {Link, useLoaderData} from 'react-router-dom';
import {ICompetition} from '../../ICompetitions';

// import {stateToHTML} from 'draft-js-export-html';
// import {convertFromRaw} from 'draft-js';
// import DOMPurify from 'dompurify';
// import ReactHtmlParser from 'react-html-parser';


type IProps = {
	competition: ICompetition,
	referrer: string,
	referrerCode?: string | null,
	lang?: 'en' | 'fa' | 'ar';
	setLang?: (lang: 'en' | 'fa' | 'ar') => void;
	// referral: string | undefined
}

type Gender = 'male' | 'female' | undefined;

const Transition = forwardRef(function Transition(
	props: TransitionProps & {
		children: ReactElement<any, any>;
	},
	ref: Ref<unknown>
) {
	return <Slide direction="up" ref={ref} {...props}/>;
});
export default function ImamRezaCompetition(props: IProps) {
	const {competition, referrer, referrerCode = null} = props;
	const {t, i18n} = useScopedTranslation();
	const [open, setOpen] = useState(false);
	const theme = useTheme();
	const [initialData, setInitialData] = useState('');
	const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
	const [mission, setMission] = useState<number>(0);
	const [results, setResults] = useState<Array<number>>([0, 0, 0, 0, 0, 0, 0, 0]);
	const [phone, setPhone] = useState<string>('');
	const [referralCode, setReferralCode] = useState<string>('');
	const [referrerFrom, setReferrerFrom] = useState<string>(referrer);
	// const [selectedIndices, setSelectedIndices] = useState<number[]>([]);
	const [gender, setGender] = useState<Gender>(undefined);
	const [type, setType] = useState<PersonalityType>('artist');
	const [lang, setLang] = useState<'fa' | 'ar' | 'en'>('fa');
	let competitionObject = useLoaderData() as ICompetition;
	useEffect(() => {
		socketCompetition.connect();
		scopedI18n.changeLanguage(lang);
		saveLang('fa');
	}, []);
	// const getHTMLData = (value: any) => {
	// 	setInitialData(stateToHTML(convertFromRaw(JSON.parse(value))));
	// };
	// useEffect(() => {
	// 	getHTMLData(competition.description);
	// }, []);
	const handleClickOpen = () => {
		setOpen(true);
	};
	
	const handleClose = () => {
		setOpen(false);
	};
	
	// function createMarkup(html: any) {
	// 	return {
	// 		__html: DOMPurify.sanitize(html)
	// 	};
	// }
	
	return (
		<>
			<CompetitionImamrezaContext.Provider value={{
				competition,
				mission,
				setMission,
				lang,
				setLang,
				results,
				setResults,
				phone,
				setPhone,
				gender,
				setGender,
				type,
				setType,
				referrerCode,
				referralCode,
				setReferralCode,
				referrerFrom
				// setSelectedIndices,
				// selectedIndices
			}}>
				<Dialog
					fullScreen={fullScreen}
					open={open}
					onClose={handleClose}
					scroll={'paper'}
					TransitionComponent={Transition}
					keepMounted={true}
					aria-labelledby="responsive-dialog-title"
					aria-describedby="alert-dialog-slide-description"
				>
					<DialogTitle id="responsive-dialog-title">
						{t('competition3.conditions')}
					</DialogTitle>
					<IconButton
						aria-label="close"
						onClick={handleClose}
						sx={{
							position: 'absolute',
							right: 8,
							top: 8,
							color: (theme) => theme.palette.grey[500]
						}}
					>
						<CloseIcon/>
					</IconButton>
					<DialogContent dividers={true}>
						{/*<DialogContentText dangerouslySetInnerHTML={createMarkup(initialData)}>*/}
						<DialogContentText dangerouslySetInnerHTML={{__html: competition.description as string}}>
							{/*{*/}
							{/*	ReactHtmlParser(initialData)*/}
							{/*}*/}
						</DialogContentText>
						<div className="flex flex-col mx-8 h-full content-center justify-around items-center">
							<Link to={`/imamreza`} state={{competition: competition}}
							      className="w-[48%] scaleAnimate">
								<div className="flex flex-row w-full justify-center">
									<div
										className="flex flex-row w-52 bg-[length:160px_40px] bg-no-repeat bg-right justify-around size-auto"
									>
										{/*<img className="w-auto h-auto" src={go} alt="play"/>*/}
									</div>
								</div>
							</Link>
						</div>
					</DialogContent>
					<DialogActions>
						<Button autoFocus onClick={handleClose}>
							{t('competition3.understood')}
						</Button>
					</DialogActions>
				</Dialog>
				<Box className="w-full h-[calc(100vh-55px)] overflow-y-auto justify-start">
					{
						mission == 0 && (
							<MainPage lang={lang} setLang={setLang}/>
						)
					}
					{
						mission == 1 && (
							<CompetitionGuide/>
						)
					}
					{
						mission == 2 && (
							<AnimatedChoices/>
						)
					}
					{
						mission == 3 && (
							<Mobile/>
						)
					}
					{
						mission == 4 && (
							<Result/>
						)
					}
				</Box>
			</CompetitionImamrezaContext.Provider>
		</>
	);
}
